export default function insertUrlParams(newParams) {
  if (window.history.pushState) {
    let searchParams = new URLSearchParams(window.location.search);
    Object.entries(newParams).forEach((entry) =>
      searchParams.set(entry[0], entry[1])
    );
    let newurl =
      window.location.protocol +
      '//' +
      window.location.host +
      window.location.pathname +
      '?' +
      searchParams.toString();
    // window.history.replaceState(null, null, newurl);
    window.history.pushState({ path: newurl }, '', newurl);
  }
}
